/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:11:29
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/countDown.js
 */
export default {
    // u-count-down 计时器组件
    countDown: {
        time: 0,
        format: 'HH:mm:ss',
        autoStart: true,
        millisecond: false
    }
}
